/**
 * Ashore API
 * All Endpoints to control your ashore account
 *
 * The version of the OpenAPI document: V1
 * Contact: info@ashoreapp.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The CreatePaymentMethodRequest model module.
 * @module model/CreatePaymentMethodRequest
 * @version V1
 */
class CreatePaymentMethodRequest {
    /**
     * Constructs a new <code>CreatePaymentMethodRequest</code>.
     * @alias module:model/CreatePaymentMethodRequest
     */
    constructor() { 
        
        CreatePaymentMethodRequest.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>CreatePaymentMethodRequest</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/CreatePaymentMethodRequest} obj Optional instance to populate.
     * @return {module:model/CreatePaymentMethodRequest} The populated <code>CreatePaymentMethodRequest</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new CreatePaymentMethodRequest();

            if (data.hasOwnProperty('cardNumber')) {
                obj['cardNumber'] = ApiClient.convertToType(data['cardNumber'], 'String');
            }
            if (data.hasOwnProperty('expMonth')) {
                obj['expMonth'] = ApiClient.convertToType(data['expMonth'], 'Number');
            }
            if (data.hasOwnProperty('expYear')) {
                obj['expYear'] = ApiClient.convertToType(data['expYear'], 'Number');
            }
            if (data.hasOwnProperty('cvc')) {
                obj['cvc'] = ApiClient.convertToType(data['cvc'], 'Number');
            }
            if (data.hasOwnProperty('zip')) {
                obj['zip'] = ApiClient.convertToType(data['zip'], 'Number');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>CreatePaymentMethodRequest</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>CreatePaymentMethodRequest</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['cardNumber'] && !(typeof data['cardNumber'] === 'string' || data['cardNumber'] instanceof String)) {
            throw new Error("Expected the field `cardNumber` to be a primitive type in the JSON string but got " + data['cardNumber']);
        }

        return true;
    }


}



/**
 * @member {String} cardNumber
 */
CreatePaymentMethodRequest.prototype['cardNumber'] = undefined;

/**
 * @member {Number} expMonth
 */
CreatePaymentMethodRequest.prototype['expMonth'] = undefined;

/**
 * @member {Number} expYear
 */
CreatePaymentMethodRequest.prototype['expYear'] = undefined;

/**
 * @member {Number} cvc
 */
CreatePaymentMethodRequest.prototype['cvc'] = undefined;

/**
 * @member {Number} zip
 */
CreatePaymentMethodRequest.prototype['zip'] = undefined;






export default CreatePaymentMethodRequest;

